import UserStore from '../../../stores/UserStore';

import ViewPersonal from './ViewPersonal.react';
import ViewMedical from './ViewMedical.react';
import ViewIdentification from './ViewIdentification.react';
import ViewHistory from './ViewHistory.react';
import ViewPolicy from './ViewPolicy.react';
import Transaction from './Transaction.react';

class ProfileMain extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            guest : this.props.guest,
            viewTransactionDetails : false
        };

        this.getFormData = this.getFormData.bind(this);
        this.getErrors = this.getErrors.bind(this);
    }

    getErrors() {
        if (this.refs && (this.refs.ViewPersonal || this.refs.ViewMedical) && (this.refs.ViewPersonal.getErrors() || this.refs.ViewMedical.getErrors())) {
            return (this.refs.ViewPersonal.getErrors() || this.refs.ViewMedical.getErrors());
        } else {
            return null;
        }
    }

    getFormData(formData, saveChanges) {
        formData = this.refs.ViewPersonal.getFormData(formData, saveChanges);
        formData = this.refs.ViewMedical.getFormData(formData);

        return formData;
    }

    render() {
        var guest     = this.props.guest;
        var page      = this.props.page;
        var selectedLocation = this.props.selectedLocation;

        var idImg = false;
        for (var i=0; i<guest.identifications.length; i++) {
        	if (guest.identifications[i].type === 'MJStateIDNo')
    			idImg = guest.identifications[i].image_url;
        }

        return (
            <div className='profile-main'>
                <div
                    className='profile-main__container'>

                    <ViewPersonal
                        page={page}
                        guest={guest}
                        checkForChanges={() => { this.props.checkForChanges(); }}
                        ref='ViewPersonal' />

                    <ViewMedical
                        page={page}
                        guest={guest}
                        selectedLocation={selectedLocation}
                        checkForChanges={() => { this.props.checkForChanges(); }}
                        ref='ViewMedical' />

                    <ViewIdentification
                        page={page}
                        guest={guest} />

                    <ViewHistory
                        page={page}
                        guest={guest}
                        viewTransactionDetails={item => { this.setState({ viewTransactionDetails : item }); }} />

                    { UserStore.getState().selectedLocation.RequirePolicySignature &&
                        <ViewPolicy
                            page={page}
                            guest={guest} />
                    }
                </div>

                { this.state.viewTransactionDetails &&
                    <Transaction
                        guest={guest}
                        selected={this.state.viewTransactionDetails}
                        onClose={() => { this.setState({ viewTransactionDetails : false }); }} />
                }
            </div>
        );
    }
}

export default ProfileMain;



/*




*/



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/ProfileMain.react.jsx